export default {
  landingPagePlaceholder: `# New Landing Page Teaser

New content preview.`
}
